import angular from 'angular';
import Navbar from './navbar/navbar';
import Footer from './footer/footer';
import Cpwd from './cpwd/cpwd';

let commonModule = angular.module('app.common', [
  Navbar,
  Footer,
  Cpwd
])

.name;

export default commonModule;



// WEBPACK FOOTER //
// ./client/app/common/common.js